import { camelCase } from "lodash";
import generateJoke from './generateJoke';
import './stylesheet/main.scss'
import laughing from './assets/laughing.svg'


const laughImg = document.getElementById('laughImg')
laughImg.src = laughing

const jokeBtn = document.getElementById('jokeBtn')
jokeBtn.addEventListener('click', generateJoke)

generateJoke()

console.log(camelCase("Hello Universe!Whatsup"));